import * as React from 'react';
import { useState, useEffect } from 'react';
import { BaseSyntheticEvent } from 'react';
import styled from 'styled-components';
import Scroll from './Scroll';


interface SelectProps {
  shape?: 'normal' | 'large' | 'small' | undefined;
  data?: Array<string|any> | undefined;
  maxList?: number;
  disabled?: boolean;
  search?: boolean;
  searchNot?: string | undefined;
  mouseState?: 'leave' | undefined;
  onClick?: VoidFunction | undefined;
  onCurrent?: VoidFunction | undefined;
}

let viewList:number;

const SelectStyle = ({
  shape = 'normal',
  data = ['Please put in the data.'],
  maxList = 6,
  search = false,
  searchNot = 'Not Found',
  mouseState,
  onClick,
  onCurrent,
  ...props
}: SelectProps) => {
  const [current, setCurrent] = useState(search ? data[0] : ''); 
  const [list, setList] = useState(data);

  viewList = maxList;

  if (search) {
    useEffect(()=>{
      const sortData = data.filter(item => item.toLowerCase().indexOf(current.toLowerCase()) > -1);
      setList(sortData);
    }, [current])

    useEffect(()=>{
      handleBarSize();
      handleDirection();
    }, [list])
  }

  return (
    <Wrap shape={shape} {...props} onMouseLeave={mouseState && handleLeave}>
      {
        search ?
          <CurrentInp type="text" placeholder={'Select'} onChange={e => handleChange(e, setCurrent)} onClick={e => handleClick(e, setCurrent, onClick)} /> :
          <CurrentBtn type="button" onClick={e => handleClick(e, null, onClick)}>{data[0]}</CurrentBtn>
      }
      <Scroll>
        <ListWrap>
          { list.length > 0 ? list.map((item, index) => (
              <List key={index}><Button type="button" onClick={e => handleCurrent(e, search, onCurrent)}>{item}</Button></List>
            )) :
              <List><Text>{searchNot}</Text></List>
          }
        </ListWrap>
      </Scroll>
    </Wrap>
)};

let activeTarget:any;
let scrollWrap:any;
let scrollArea:any;
let valueCheck:boolean = false;
let currentValue:string | undefined;

const handleChange = (e:BaseSyntheticEvent, setCurrent:any) => {
  setCurrent(e.target.value);
}

const handleClick = (e:BaseSyntheticEvent, setCurrent: any, callback:VoidFunction | undefined) => {
  valueCheck = false;
  const { target } = e;

  if (activeTarget && activeTarget !== target.parentNode) {
    activeTarget.classList.remove('focus');
    scrollWrap.classList.remove('up');
    document.removeEventListener('click', handleOutClick);
  }

  target.parentNode.classList.toggle('focus');
  scrollWrap = target.nextSibling;
  scrollWrap.classList.remove('up');
  scrollArea = target.nextSibling.childNodes[0];
  scrollArea.scrollTop = 0;

  activeTarget = target.parentNode;

  if (target.parentNode.classList.contains('focus')) {

    if (activeTarget.childNodes[0].nodeName === 'INPUT') {
      setCurrent('');
      activeTarget.childNodes[0].removeAttribute('readonly');
      if (activeTarget.childNodes[0].value) {
        activeTarget.childNodes[0].placeholder = activeTarget.childNodes[0].value;
      }
      activeTarget.childNodes[0].value = '';
    }

    handleBarSize();
    handleDirection();

    document.addEventListener('click', handleOutClick);
  } else {
    activeTarget.childNodes[0].nodeName === 'INPUT' && activeTarget.childNodes[0].setAttribute('readonly','true');
    valueCheck = false;
  }

  callback && callback();
}

const handleBarSize = () => {
  if (!scrollWrap) { return };
  const widthPercent = (scrollArea.clientWidth * 100 / scrollArea.scrollWidth);
  const heightPercent = (scrollArea.clientHeight * 100 / scrollArea.scrollHeight);
  scrollWrap.querySelector('.axis-x > div').style.width = (widthPercent < 100) ? (widthPercent + '%') : '';
  scrollWrap.querySelector('.axis-y > div').style.height = (heightPercent < 100) ? (heightPercent + '%') : '';
}

const handleDirection = () => {
  if (!scrollWrap) { return };
  const scrollRect = scrollWrap.getBoundingClientRect();
  const scrollAxis = scrollRect.y + scrollRect.height + 10;

  if (scrollAxis >= window.innerHeight) {
    scrollWrap.classList.add('up');
  }
}

const handleOutClick = (e:any) => {
  let parentTarget = e.target;

  if (e.target !== activeTarget) {
    let i = 0;
    do {
      parentTarget = parentTarget.parentNode;
      i += 1;
    } while (activeTarget !== parentTarget && i < 4);
  }

  if (activeTarget && parentTarget !== activeTarget) {
    activeTarget.classList.remove('focus');
    scrollWrap.classList.remove('up');

    if (activeTarget.childNodes[0].nodeName === 'INPUT') {
      activeTarget.childNodes[0].setAttribute('readonly','true');
      if (valueCheck) {
        activeTarget.childNodes[0].placeholder = currentValue;
        valueCheck = false;
      } else {
        activeTarget.childNodes[0].value = activeTarget.childNodes[0].placeholder;
      }
    }

    activeTarget = null;

    document.removeEventListener('click', handleOutClick);
  }
}

const handleCurrent = (e:BaseSyntheticEvent, search:boolean, callback:VoidFunction | undefined) => {
  valueCheck = true;
  currentValue = e.target.innerText;
  activeTarget.childNodes[0][search ? 'value' : 'innerText'] = currentValue;
  callback && callback();
}

const handleLeave = () => {
  if (activeTarget.classList.value.contains('focus')) {
    activeTarget.classList.remove('focus');
    scrollWrap.classList.remove('up');
  }
}


export default SelectStyle;


interface StyleProps {
  shape?: 'normal' | 'large' | 'small' | undefined;
  disabled?: boolean;
}

const padding = 'padding: 0 ';
const padding5 = 'padding: 5px ';
let paddingNum = '';
const height = 'height:';
let heightNum = '';
const font = 'font-size:'
let fontNum = '';

const color = 'color:';
let colorNum = '#666';
const border = 'border: 1px solid ';
let bdColorNum = '#cfcfcf';
const bg = 'background-color:';
let bgColorNum = '#fff';

const FuncButton = (p:StyleProps) => {
  switch(p.shape) {
    // case 'large': paddingNum = '20px'; heightNum = '50px'; fontNum = '18px'; break;
    case 'small': paddingNum = '10px'; heightNum = '30px'; fontNum = '12px'; break;
    case 'normal':
    default: paddingNum = '20px'; heightNum = '40px'; fontNum = '14px' ; break;
  }

  const resultShape = `${padding}${paddingNum}; ${height}${heightNum};${font}${fontNum};`;

  if (p.disabled) {
    colorNum = '#bababa'; bdColorNum = '#cfcfcf'; bgColorNum = '#f9f9f9';
  }

  const resultColor = `${color}${colorNum};${border}${bdColorNum};${bg}${bgColorNum};`

  return resultShape + resultColor;
};

const FuncUl = (p:StyleProps) => {
  switch(p.shape) {
    // case 'large': heightNum = '30px'; fontNum = '12px'; break;
    case 'small': heightNum = `${18 * viewList}px`; break;
    case 'normal':
    default: heightNum = `${36 * viewList}px`; break;
  }

  const resultShape = `max-${height}${heightNum};`;

  return resultShape;
};

const FuncItem = (p:StyleProps) => {
  switch(p.shape) {
    // case 'large': paddingNum = '20px'; heightNum = '50px'; fontNum = '18px'; break;
    case 'small': paddingNum = '10px'; heightNum = '18px'; fontNum = '12px'; break;
    case 'normal':
    default: paddingNum = '20px'; heightNum = '36px'; fontNum = '14px' ; break;
  }

  const resultShape = `${padding5}${paddingNum}; min-${height}${heightNum};${font}${fontNum};`;

  return resultShape;
};

const Wrap = styled.div<StyleProps>`
  display: inline-block;
  position: relative;

  &.focus {
    &> button {
      border-color: #b6aa92;
    }

    &> div {
      display: block;
    }

    &> div > div {
      ${p => FuncUl(p)}
    }
  }

  &> div {
    display: none;
    position: absolute;
    top: calc(100% - 1px); left: 0;
    width: 100%;
    border: 1px solid #b6aa92;
    border-radius: 0 0 3px 3px;
    background: #fff;
    box-shadow: 0 2px 1px 0 rgba(0, 0, 0, 0.1);
    overflow: hidden;
    z-index: 10;
    &.up {
      top: auto;
      bottom: calc(100% - 1px);
      box-shadow: 0 -2px 1px 0 rgba(0, 0, 0, 0.1);
    }
  }

  &> button,
  &> input {
    ${p => FuncButton(p)}
  }

  &> div > div > ul {
    & button, p {
      ${p => FuncItem(p)} 
    }
  }
`;

const CurrentBtn = styled.button`
  border-radius: 3px;
  text-align: left;
`;

const CurrentInp = styled.input`
  border-radius: 3px;
  text-align: left;
`;

const ListWrap = styled.ul`
  width: 100%;
  background: #fff;
`;

const List = styled.li`
  display: block;
  position: relative;
`;

const Button = styled.button`
  min-width: 100%;
  text-align: left;
  word-break: break-word;

  &:hover {
    background-color: rgba(182, 170, 146, 0.1);
  }
`;

const Text = styled.p`
  display: flex;
  align-items: center;
  min-width: 100%;
  text-align: center;
`;



// WEBPACK FOOTER //
// ./src/styles/ui/Select.tsx